export default "__VITE_ASSET__jHoeICKM__"